import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeCustomerGroupCreate,
  detail: routeCustomerGroupDetail,
  home: routeCustomerGroupSettingsHome,
  root: routeCustomerGroupSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-customer-group',
  createPath: 'new-customer-group',
  detailName: 'customer-group-detail',
  doctype: DOCTYPES.CUSTOMER_GROUP,
  homeName: 'customer-group',
  path: 'customer-group',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/customerGroup/AddCustomerGroup.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/customerGroup/ViewCustomerGroup.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export {
  routeCustomerGroupCreate,
  routeCustomerGroupDetail,
  routeCustomerGroupSettingsHome,
  routeCustomerGroupSettingsRoot,
}
